<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
import type { Vendor } from '~/types/vendor.ts';
import { getTranslatedProperty } from '@shopware-pwa/helpers-next';

const { getFormattedPrice } = usePrice();

defineProps<{
    vendor: Vendor | undefined;
    miniCart: boolean;
}>();

const { vendorTotals, getShippingMethodCost, amountTillFreeShipping } = useGroupedCartItems();
</script>

<template>
    <div
        class="flex flex-col justify-between bg-neutral-300 p-4 text-sm md:flex-row"
        :class="{ '!flex-col': miniCart }"
    >
        
<FormKitLazyProvider config-file="true">
<div>
            <div
                v-if="amountTillFreeShipping(vendor?.id) !== Infinity"
                class="flex flex-col"
            >
                <div class="flex place-items-start gap-2">
                    <span>
                        <FormKitIcon
                            icon="truck-fast"
                            class="relative -bottom-0.5 mr-2 inline-block h-4 w-4 shrink-0"
                        />
                        <!-- v-html is necessary because we need to render html -->
                        <!-- eslint-disable vue/no-v-html -->
                        <span
                            v-html="
                                $t('checkout.cart.freeShippingHint', {
                                    amount: getFormattedPrice(amountTillFreeShipping(vendor?.id)),
                                })
                            "
                        />
                    </span>
                </div>
                <LocaleLink
                    :aria-label="$t('checkout.cart.vendorProductsLink')"
                    :to="getTranslatedProperty(vendor, 'homepage')"
                    class="underline"
                >
                    {{ $t('checkout.cart.vendorProductsLink') }}
                </LocaleLink>
            </div>
        </div>
        <div
            class="mt-4 md:mt-0 md:w-48"
            :class="{ '!mt-4 !w-full': miniCart }"
        >
            <div class="flex w-full place-items-center justify-between">
                <p class="">
                    {{ $t('checkout.cart.subTotal') }}
                </p>
                <p class="font-extrabold">
                    {{ getFormattedPrice(vendorTotals[vendor?.id]) }}
                </p>
            </div>
            <div class="flex w-full place-items-center justify-between">
                <p class="">
                    {{ $t('checkout.cart.shippingCosts') }}
                </p>

                <p class="font-extrabold">{{ getFormattedPrice(getShippingMethodCost(vendor?.id).totalPrice) }}</p>
            </div>
        </div>
</FormKitLazyProvider>

    </div>
</template>
